/**
 * Client-side mirror of backend table rotation helpers for optimistic UI updates.
 */

function slotFromTable(tableRow, position) {
  if (!tableRow?.assignments) return null;
  return (
    tableRow.assignments.find((a) => a.player_position === position) || null
  );
}

function tableHasBothSlots(tableRow) {
  return Boolean(slotFromTable(tableRow, "Player1") && slotFromTable(tableRow, "Player2"));
}

export function selectTablesInUseForRotation(tablesSorted, presentPlayerIds = null) {
  let used = tablesSorted.filter(tableHasBothSlots);

  if (!(presentPlayerIds instanceof Set) || presentPlayerIds.size === 0) {
    return used;
  }

  used = used.filter((table) => {
    const p1 = slotFromTable(table, "Player1");
    const p2 = slotFromTable(table, "Player2");
    return (
      presentPlayerIds.has(String(p1.player_id)) &&
      presentPlayerIds.has(String(p2.player_id))
    );
  });

  const maxTables = Math.ceil(presentPlayerIds.size / 2);
  if (maxTables > 0 && used.length > maxTables) {
    used = used.slice(0, maxTables);
  }

  return used;
}

export function buildTableRotationMoves(tablesSorted, direction) {
  const n = tablesSorted.length;
  if (n < 2) return [];

  const moves = [];

  for (let i = 0; i < n; i += 1) {
    const fromTable = tablesSorted[i];
    const isFirst = i === 0;
    const isLast = i === n - 1;

    for (const position of ["Player1", "Player2"]) {
      const assignment = slotFromTable(fromTable, position);
      if (!assignment) continue;

      let destIndex = i;
      let destPosition = position;

      if (direction === "right") {
        if (isFirst && position === "Player2") {
          destIndex = i;
          destPosition = "Player1";
        } else if (isLast && position === "Player1") {
          destIndex = i;
          destPosition = "Player2";
        } else if (position === "Player1") {
          destIndex = i + 1;
          destPosition = "Player1";
        } else {
          destIndex = i - 1;
          destPosition = "Player2";
        }
      } else if (isFirst && position === "Player1") {
        destIndex = i;
        destPosition = "Player2";
      } else if (isLast && position === "Player2") {
        destIndex = i;
        destPosition = "Player1";
      } else if (position === "Player1") {
        destIndex = i - 1;
        destPosition = "Player1";
      } else {
        destIndex = i + 1;
        destPosition = "Player2";
      }

      const toTable = tablesSorted[destIndex];
      moves.push({
        assignment,
        table_id: toTable.table_id,
        player_position: destPosition,
        from_table_number: fromTable.table_number,
        to_table_number: toTable.table_number,
      });
    }
  }

  return moves;
}
